/*@ngInject*/
const CurrentSubmissionModel = function ($rootScope, coreConstant, submissionConstant) {
    var openSubmissionList = [],
        selectedSubmission = null,
        currentSubmission = null,
        currentNewSubmission = null,
        registrations = [],
        actionsRegistrations = {},
        doCreateDraftEmail = false,
        sendMailUserId;

    function findSubmission(submissionId) {
        return _.find(openSubmissionList, {id: submissionId});
    }

    this.getSelectedSubmission = function () {
        return selectedSubmission;
    };

    this.setSelectedSubmission = function (submission) {
        selectedSubmission = submission;
    };

    this.getCurrentSubmission = function () {
        return currentSubmission || currentNewSubmission;
    };

    this.getCurrentNewSubmission = function () {
        return currentNewSubmission;
    };

    this.getSubmissionById = function (submissionId) {
        return findSubmission(submissionId);
    };

    this.setCurrentSubmission = function (submission) {
        var existingSubmission = findSubmission(submission.id);
        currentSubmission = submission;
        selectedSubmission = currentSubmission;

        if (!existingSubmission) {
            openSubmissionList.push(submission);
        } else {
            this.updateOpenSubmission(submission);
        }

        $rootScope.$broadcast(submissionConstant.event.CURRENT_SUBMISSION_CHANGE, currentSubmission);
    };

    this.setCurrentNewSubmission = function (newSubmission) {
        currentNewSubmission = newSubmission;
    };

    this.openSubmission = function (submission) {
        openSubmissionList.push(submission);
    };

    this.getOpenSubmissionList = function () {
        return openSubmissionList;
    };

    this.resetOpenSubmissionList = function () {
        openSubmissionList = [];
    };

    this.closeSubmission = function (submissionId) {
        var openSubmissionIndex = _.indexOf(openSubmissionList, findSubmission(submissionId)),
            isCurrentSubmission = currentSubmission ? submissionId === currentSubmission.id : false,
            isSelectedSubmission = selectedSubmission ? submissionId === selectedSubmission.id : false,
            isCurrentNewSubmission = currentNewSubmission ? submissionId === currentNewSubmission.id : false,
            hasOpenSubmissions;

        if (openSubmissionIndex >= 0) {
            openSubmissionList.splice(openSubmissionIndex, 1);
            hasOpenSubmissions = openSubmissionList.length > 0;

            if (isCurrentNewSubmission) {
                $rootScope.$broadcast(coreConstant.event.CLOSE_SUBMISSION_VIEW, currentNewSubmission.id);
            } else if (isCurrentSubmission) {
                if (hasOpenSubmissions) {
                    currentSubmission = openSubmissionList[0];
                    selectedSubmission = currentSubmission;
                    $rootScope.$broadcast(submissionConstant.event.CURRENT_SUBMISSION_CHANGE, currentSubmission);
                } else {
                    currentSubmission = null;
                    selectedSubmission = null;
                    $rootScope.$broadcast(submissionConstant.event.CLOSE_SUBMISSION_MODULE, currentSubmission);
                }
            } else if (isSelectedSubmission) {
                if (hasOpenSubmissions) {
                    selectedSubmission = openSubmissionList[0];
                }
            }

            $rootScope.$broadcast(submissionConstant.event.OPEN_SUBMISSION_LIST_CHANGE);
        }
    };

    this.updateOpenSubmission = function (submission) {
        var openSubmissionIndex = _.indexOf(openSubmissionList, findSubmission(submission.id)),
            isCurrentSubmission = currentSubmission ? submission.id === currentSubmission.id : false,
            submissionExists = openSubmissionIndex !== -1;

        if (submissionExists) {
            openSubmissionList[openSubmissionIndex] = submission;

            if (isCurrentSubmission) {
                currentSubmission = submission;
                selectedSubmission = currentSubmission;
            }
            $rootScope.$broadcast(submissionConstant.event.OPEN_SUBMISSION_LIST_CHANGE);
            $rootScope.$broadcast(submissionConstant.event.REFRESH_SUBMISSION, submission);
        }
    };

    this.resetCurrentSubmission = function () {
        // @todo: remove the submission from the submissionList
        currentSubmission = null;
        $rootScope.$broadcast(submissionConstant.event.CURRENT_SUBMISSION_CHANGE);
    };

    this.addRegistration = function (url) {
        var doAdd = true;
        _.each(registrations, function (registration) {
            if (JSON.stringify(url) === JSON.stringify(registration)) {
                doAdd = false;
            }
        });
        if (doAdd) {
            registrations.push(url);
        }
    };

    this.addActionsRegistration = function (key, url) {
        actionsRegistrations[key] = url;
    };

    this.hasActionsRegistration = function (key) {
        return !_.isNil(actionsRegistrations[key]);
    };

    this.getActionsRegistration = function (key) {
        return actionsRegistrations[key];
    };

    this.removeActionsRegistration = function (key) {
        var url = actionsRegistrations[key];
        delete actionsRegistrations[key];
        return url;
    };

    this.clearActionsRegistrations = function () {
        actionsRegistrations = {};
    };

    this.clearRegistrations = function () {
        registrations = [];
        actionsRegistrations = {};
    };

    this.getRegistrationsClone = function () {
        return _.clone(registrations);
    };

    this.getActionsRegistrationsClone = function () {
        return _.cloneDeep(actionsRegistrations);
    };

    $rootScope.$on(coreConstant.event.UPDATE_SUBMISSION, function (event, submission) {
        this.updateOpenSubmission(submission);
    }.bind(this));
};

angular.module('gw-um-submission')
    .service('currentSubmissionModel', CurrentSubmissionModel);
